var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gold-link",attrs:{"role":"button","tabindex":"0"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.emitClickEvent.apply(null, arguments)},"click":_vm.emitClickEvent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }